export default {"src":"https://static.finncdn.no/_c/travel/_next/static/media/noImage.0932de0d.svg","height":360,"width":480,"blurWidth":0,"blurHeight":0};